import React from 'react'
import PropTypes from 'prop-types'
import OrLine from '../components/orLine'
import { localsMessages } from '../utility/getTemplateData'

let messages = localsMessages('guest/guestButton')

class GuestButton extends React.Component {
	constructor() {
		super();
	}

	render () {
		let debitorcredit = messages.label && messages.label.debitorcredit
		return (
			<div>
				<div className="wrap_max_361">
					<OrLine />
				</div>
				<div className="col-xs-12 col-sm-12 col-md-12 text-center">
					<a href="#"
						style={{ maxWidth: 350, marginTop: 8, marginBottom: 10, fontSize: 15 }}
						className="vx_btn vx_btn-block vx_btn-secondary"
						id="payWithGuest"
						onClick={this.props.handleGuest}>
						{debitorcredit}
					</a>
				</div>
			</div>
		);
	}
}

GuestButton.propTypes = {
	label: PropTypes.string,
	handleGuest: PropTypes.func,
};

export default GuestButton



// WEBPACK FOOTER //
// ./components/guestButton.js